var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-container"},[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('p',{key:_vm.text.id,staticClass:"text"},[_vm._v(_vm._s(_vm.text.val))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }